module.exports = __webpack_public_path__ + "img/win_download.baa9e850.svg";